import React, { useEffect, useState } from 'react'
import injectStyles from 'react-jss'
import cn from 'classnames'
import InputLabel from '@material-ui/core/InputLabel'
import { Input } from '@material-ui/core'
import {
  minLength as validationOnMinLength,
  validEmail,
} from '../../../shared/validation'

import { styles } from './styles'

const isOnlyLettersAndSpacesRegx = /^[A-Za-z\s-]*$/

const errorOnlyString = value =>
  !isOnlyLettersAndSpacesRegx.test(value)
    ? 'Can only be made up of letters & space'
    : null

const InputStyled = ({
  label,
  classes,
  value,
  onChange,
  required = false,
  onlyString = false,
  email = false,
  minLength = null,
  isTouched: isTouchedProps,
  additionalError = '',
  inputProps = {},
  placeholder = '',
  className,
  disableError = false,
  cypress_id,
  description = '',
  isNewError = false,
}) => {
  const [isTouched, setIsTouched] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => {
    if (isTouchedProps) {
      setIsTouched(true)
    }
  }, [isTouchedProps])

  useEffect(() => {
    if (isTouched) {
      if (required && isTouched && !value.trim()) {
        setError('required')
      }
    }
  }, [isTouched])

  const onInputChange = (value, label) => {
    let error = ''

    if (value.trim() && email) {
      const errorMessage = validEmail(value, 'Email is not valid')
      if (errorMessage) {
        error = errorMessage
      } else {
        error = ''
      }
    }

    if (!email && (minLength || onlyString) && value) {
      const errorMessageMinLength = minLength
        ? validationOnMinLength(minLength, label)(value)
        : null

      const errorMessageOnlyString = onlyString ? errorOnlyString(value) : null
      const errorMessage = errorMessageMinLength || errorMessageOnlyString

      if (errorMessage) {
        error = errorMessage
      } else {
        error = ''
      }
    }

    if (required && !value.trim()) {
      error = 'required'
    }

    setError(error)
    onChange(value, error)
  }

  return (
    <div className={cn(classes.wrap, { [className]: !!className })}>
      {label ? (
        <InputLabel className={classes.label}>
          <span>
            {label} {required ? <span style={{ color: 'red' }}>*</span> : null}
          </span>
          {isNewError ? (
            <span className={cn(classes.error)}>
              {error || additionalError}
            </span>
          ) : null}
        </InputLabel>
      ) : null}
      <Input
        className={classes.input}
        value={value}
        onChange={event => onInputChange(event.target.value, label)}
        disableUnderline={true}
        onBlur={() => setIsTouched(true)}
        placeholder={placeholder || label}
        cypress_id={cypress_id}
        {...inputProps}
      />
      {description ? (
        <div className={classes.description}>{description}</div>
      ) : null}
      {disableError ? null : !isNewError && (error || additionalError) ? (
        <div className={classes.error}>{error || additionalError}</div>
      ) : (
        <div className={classes.emptyMargin} />
      )}
    </div>
  )
}

export default injectStyles(styles)(InputStyled)
